import _ from 'underscore';
import Localizer from 'localizer';
import Backbone from 'backbone';
import templateHtml from 'pages/settings/templates/GarminDeviceUploadModal.html';

export default Backbone.View.extend({
    template: _.template(templateHtml),

    events: {
        'change #accountDeviceSyncToggle': 'onAccountDeviceSyncToggle'
    },

    initialize: function(args) {
        this.onDeviceSyncToggle = args.onDeviceSyncToggle;
        this.accountDeviceSyncPref = args.accountDeviceSyncPref;

        this.accountDeviceSyncPref.on('change', () => {
            this.updateSwitch(this.accountDeviceSyncPref.equalsIgnoreCase('true'));
        });
    },

    render: function() {
        this.$el.html(
            this.template({
                Localizer: Localizer,
                checked: this.accountDeviceSyncPref.equalsIgnoreCase('true')
            })
        );
        return this;
    },

    updateSwitch: function(value) {
        this.$('#accountDeviceSyncToggle').toggleClass('checked', value);
    },

    onAccountDeviceSyncToggle: function(e) {
        let deviceSync = !jQuery(e.currentTarget).hasClass('checked');
        this.onDeviceSyncToggle(deviceSync);
    }
});
